class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    this.hiddenClass = 'show-more-item--hidden';

    const button = this.querySelector('button');

    button.addEventListener('click', (event) => {
      this.expandShowMore(event);

      // Move focus to the next element.
      const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item')
      if (nextElementToFocus && !nextElementToFocus.classList.contains(this.hiddenClass)) {
        nextElementToFocus.querySelector('input').focus()
      }
    });

    this.isOpen = false;
  }

  get open() {
    return this.isOpen;
  }

  set open(value) {
    if (this.isOpen === value) {
      return;
    }

    this.isOpen = value;

    // Update toggle buttont text.
    this.querySelectorAll('.label-text').forEach(
      element => element.classList.toggle('hidden')
    );

    // Update show more items.
    const parentDisplay = this.closest('.parent-display');
    parentDisplay.querySelectorAll('.show-more-item').forEach(
      item => item.classList.toggle(this.hiddenClass)
    );
  }

  expandShowMore() {
    this.open = !this.open;
  }
}

customElements.define('show-more-button', ShowMoreButton);

